import { useEffect } from "react";

const useAutofocus = (options: any) => {
  const { autoFocus = false, ref, currentValue = "" } = options;

  useEffect(() => {
    if (autoFocus && !currentValue) {
      setTimeout(() => {
        ref?.current?.focus();
      }, 20);
    }
  }, [autoFocus]);
};

export default useAutofocus;
